import React, { useCallback, useEffect, useRef } from 'react';
import { translations } from '../translations';

function Features({ language, onFeatureClick }) {
  const t = translations[language];
  const gridRef = useRef(null);
  const scrollCarouselByOne = useCallback((direction) => {
    const el = gridRef.current;
    if (!el) return;
    const firstCard = el.querySelector('.feature-card');
    const gap = 14;
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : el.clientWidth * 0.84;
    el.scrollBy({ left: direction * (cardWidth + gap), top: 0, behavior: 'smooth' });
  }, []);

  const resetMobileCarousel = useCallback(() => {
    const el = gridRef.current;
    if (!el) return;
    if (window.innerWidth > 900) return;
    const previousSnap = el.style.scrollSnapType;
    el.style.scrollSnapType = 'none';
    el.scrollLeft = 0;
    el.scrollTo({ left: 0, top: 0, behavior: 'auto' });
    window.requestAnimationFrame(() => {
      el.scrollLeft = 0;
      el.scrollTo({ left: 0, top: 0, behavior: 'auto' });
      el.style.scrollSnapType = previousSnap || 'x mandatory';
    });
  }, []);

  useEffect(() => {
    resetMobileCarousel();
    const timer = window.setTimeout(resetMobileCarousel, 120);
    return () => window.clearTimeout(timer);
  }, [language, resetMobileCarousel]);

  useEffect(() => {
    const onPageShow = () => resetMobileCarousel();
    const onOrientation = () => {
      window.setTimeout(resetMobileCarousel, 90);
    };
    window.addEventListener('pageshow', onPageShow);
    window.addEventListener('orientationchange', onOrientation);
    return () => {
      window.removeEventListener('pageshow', onPageShow);
      window.removeEventListener('orientationchange', onOrientation);
    };
  }, [resetMobileCarousel]);

  return (
    <section className="features">
      <div className="features-inner">
        <p className="section-label">{t.sectionLabel}</p>
        <h2 className="section-title">
          {t.sectionTitle[0]}
          <br />
          {t.sectionTitle[1]}
        </h2>

        <div className="features-mobile-nav">
          <button
            type="button"
            className="features-mobile-nav-btn"
            onClick={() => scrollCarouselByOne(-1)}
            aria-label={language === 'ro' ? 'Card anterior' : 'Previous card'}
          >
            ← {language === 'ro' ? 'Prev' : 'Prev'}
          </button>
          <button
            type="button"
            className="features-mobile-nav-btn"
            onClick={() => scrollCarouselByOne(1)}
            aria-label={language === 'ro' ? 'Card următor' : 'Next card'}
          >
            {language === 'ro' ? 'Next' : 'Next'} →
          </button>
        </div>

        <div className="features-grid" ref={gridRef}>
          {t.features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <span className="feature-icon">{feature.icon}</span>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.desc}</p>
              <button
                className="btn-card"
                onClick={() => onFeatureClick(index)}
              >
                {feature.btn}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
